import { render, staticRenderFns } from "./dyhUpload.vue?vue&type=template&id=645e1667&scoped=true&"
import script from "./dyhUpload.vue?vue&type=script&lang=js&"
export * from "./dyhUpload.vue?vue&type=script&lang=js&"
import style0 from "./dyhUpload.vue?vue&type=style&index=0&id=645e1667&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645e1667",
  null
  
)

export default component.exports